module.exports = __webpack_public_path__ + "static/media/notion.527ea2c1.png";